interface YinYangScaleProps {
  label: string;
  value: number; // -5 to +5
  delay?: number;
}

export function YinYangScale({ label, value, delay = 0 }: YinYangScaleProps) {
  // value: -5 (full Yin) to +5 (full Yang)
  // Map to 0-100 percentage where 50 is center
  const position = ((value + 5) / 10) * 100;

  const getLabel = () => {
    if (value > 1) return "Ян";
    if (value < -1) return "Инь";
    return "Баланс";
  };

  return (
    <div
      className="animate-fade-up"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="font-body text-[13px] font-medium" style={{ color: "var(--foreground)" }}>{label}</span>
        <span
          className="font-body text-[11px] font-medium tracking-[0.08em] uppercase"
          style={{ color: "var(--muted-foreground)" }}
        >
          {getLabel()}
        </span>
      </div>
      <div className="relative h-[6px] rounded-full overflow-hidden" style={{ background: "var(--muted)" }}>
        {/* Gradient track */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background: "linear-gradient(90deg, oklch(0.55 0.12 350 / 0.2), oklch(0.92 0.01 75 / 0.08), oklch(0.48 0.14 12 / 0.2))",
          }}
        />
        {/* Center line */}
        <div className="absolute top-0 bottom-0 left-1/2 w-px" style={{ background: "var(--border)" }} />
        {/* Indicator dot */}
        <div
          className="absolute top-1/2 -translate-y-1/2 w-[12px] h-[12px] rounded-full transition-all duration-700 ease-out"
          style={{
            left: `calc(${position}% - 6px)`,
            background: value > 0.5
              ? "var(--rose)"
              : value < -0.5
              ? "oklch(0.55 0.12 350)"
              : "var(--gold)",
            boxShadow: "0 1px 4px oklch(0 0 0 / 0.15)",
          }}
        />
      </div>
    </div>
  );
}

interface YinYangPanelProps {
  balance: {
    skeleton: number;
    flesh: number;
    features: number;
    overall: number;
  };
}

export function YinYangPanel({ balance }: YinYangPanelProps) {
  const items = [
    { label: "Костная структура", value: balance.skeleton },
    { label: "Ткани тела", value: balance.flesh },
    { label: "Черты лица", value: balance.features },
    { label: "Общий баланс", value: balance.overall },
  ];

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between px-0.5">
        <span
          className="font-body text-[10px] font-semibold tracking-[0.12em] uppercase"
          style={{ color: "var(--muted-foreground)" }}
        >
          Ян (угловатость)
        </span>
        <span
          className="font-body text-[10px] font-semibold tracking-[0.12em] uppercase"
          style={{ color: "var(--muted-foreground)" }}
        >
          Инь (мягкость)
        </span>
      </div>
      <div className="space-y-5">
        {items.map((item, i) => (
          <YinYangScale
            key={item.label}
            label={item.label}
            value={item.value}
            delay={i * 80}
          />
        ))}
      </div>
    </div>
  );
}
